import { createFileRoute } from "@tanstack/react-router";
import { UsagePage } from "@/features/me/UsagePage";

export const Route = createFileRoute("/app/me/usage")({ component: UsagePage });
